import { render, staticRenderFns } from "./OrganizationType.vue?vue&type=template&id=93feac8a&"
import script from "./OrganizationType.vue?vue&type=script&lang=js&"
export * from "./OrganizationType.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationType.vue?vue&type=style&index=0&id=93feac8a&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OrganizationType.vue"
export default component.exports